<template>
    <div ref="campaignPdfDialog">
        <app-dialog :isCampaignPdf="true" :value="value" @input="pdfDialogStatus($event)" :title="tb('Campanhas atuais')" width="75vw" :isResponsive="true" :isPersistent="true" :showActions="true" contentStyle="height: 75vh; max-height: 75vh; overflow-y: scroll;">
            <template v-slot:content>
                <div>
                    <v-overlay :value="isLoading">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>

                    <vue-pdf-embed v-if="pdfUrl" :key="pdfUrl" :source="pdfUrl" @rendered="handleDocumentRender" @error="handlePdfError"/>
                </div>
            </template>

            <template v-slot:buttons="{}">
                <v-btn text outlined class="myprovet-btn-cancel" @click="pdfDialogStatus(false)">{{ tb('Fechar') }}</v-btn>
                <v-btn text outlined class="myprovet-btn-ok" @click="downloadFile()">{{ tb('Transferir') }}</v-btn>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useCategoriesStore } from '@/Stores/categories';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import { axios } from '@/Services/Backend';

export default {
    components: {
        VuePdfEmbed,
    },

    props: {
        value: {
            type: Boolean,
        },
    },

    data: () => ({
        isLoading: true,
        pdfUrl: '/api/campaigns/pdf',
    }),

    computed: {
        ...mapStores(useCategoriesStore),
    },

    methods: {
        handlePdfError(err) {
            this.isLoading = false;
            this.$emit('onCancel', false);
            console.error('❌ PDF Render Error:', err);
            // mostra mais detalhes no console
            if (err?.message) console.warn('Message:', err.message);
            if (err?.stack) console.warn('Stack:', err.stack);
            //this.errorMessage = 'Erro ao renderizar o PDF.';
        },

        handleDocumentRender() {
            this.isLoading = false;
        },

        pdfDialogStatus(event) {
            if (event) {
                this.pdfUrl = null;
            } else {
                this.$emit('onCancel', event);
            }
        },

        async downloadFile() {
            try {
                const response = await axios({
                    url: this.pdfUrl,
                    method: 'GET',
                    responseType: 'blob',
                });

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const fileURL = window.URL.createObjectURL(blob);
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.download = 'Campanhas.pdf';
                fileLink.click();
                window.URL.revokeObjectURL(fileURL);
            } catch (error) {
                console.error('Error downloading PDF:', error);
            }
        },
    },
};
</script>

<style>
.vue-pdf-embed canvas {
    width: 100% !important;
    height: 100% !important;
}
</style>
